<section class="mtb">
  <div class="trip-detail-popup-right">
    <div class="header">
      <div class="row">
        <div class="col-sm-9">
          <h5>Driver Route Details</h5>
        </div>
        <div class="image-fluid col-sm-3">
          <img
            (click)="close()"
            src="../../../assets/img/icons8-macos-close-60.png"
            class="close-icons"
          />
        </div>
      </div>
    </div>
    <mat-divider></mat-divider>
  </div>
  <div class="view-details">
    <div class="route-details">
      <div class="row mtb">
        <div class="col-md-6 d-flex justify-content-between">
          <div class="fare">{{ driverData.driver_route_unique_id }}</div>
          <div class="fare">{{ driverData.trip_details[0]?.trip_id }}</div>
        </div>
      </div>
      <div class="row mtb">
        <div class="col-md-6 d-flex justify-content-between">
          <div class="cost">
            {{ driverData.createdAt | date : "dd-MM-yyyy" }},
            {{ driverData.createdAt | date : "hh:mm:ss a" }}
          </div>
          <div class="cost">
            <!-- ₹ {{ driverData.route_fare | number : "1.2-2" }} /- -->
            <!-- ₹ -->
            <!-- {{
              (driverData.workorderInfo[0]?.pay_as_load_quantity ===
              "loaded_quantity"
                ? (driverData.tripInfo?.workOrderOtherDetails?.price_per_ton ||
                    0) *
                  (driverData.tripInfo?.workOrderOtherDetails?.loading_point ||
                    0)
                : driverData.workorderInfo[0]?.pay_as_load_quantity ===
                  "unloaded_quantity"
                ? (driverData.tripInfo?.workOrderOtherDetails?.price_per_ton ||
                    0) *
                  (driverData.tripInfo?.workOrderOtherDetails
                    ?.unloading_point || 0)
                : driverData.trip_payment_info[0]?.price_details?.amount_paid ??
                  0
              ) | number : "1.2-2"
            }} -->
            <!-- ₹ {{ getTotalFare() | number : "1.2-2" }} /- -->
            <!-- For Normal Customers -->
            <div *ngIf="driverData?.trip_details[0]?.userInfo?.user_type === 'customer'">
              ₹ {{ driverData.total_fare | number: '1.2-2' }} /-
            </div>

            <!-- For Corporate Users -->
            <div *ngIf="driverData?.trip_details[0]?.userInfo?.user_type === 'corporate'">
              ₹
              {{
                driverData.bidDetails[0]?.trip_status === 'pending' ||
                driverData.bidDetails[0]?.trip_status === 'trip_not_booked'
                  ? (0 | number: '1.2-2')
                  : (
                      driverData.workorderInfo[0]?.pay_as_load_quantity === 'loaded_quantity'
                        ? (driverData.tripInfo?.workOrderOtherDetails?.price_per_ton || 0) *
                          (driverData.tripInfo?.workOrderOtherDetails?.loading_point || 0)
                        : driverData.workorderInfo[0]?.pay_as_load_quantity === 'unloaded_quantity'
                        ? (driverData.tripInfo?.workOrderOtherDetails?.price_per_ton || 0) *
                          (driverData.tripInfo?.workOrderOtherDetails?.unloading_point || driverData.tripInfo?.workOrderOtherDetails?.loading_point || 0)
                        : driverData.trip_payment_info[0]?.price_details?.amount_paid ||
                          driverData.total_fare || 0
                    ) | number: '1.2-2'
              }}
              /-
            </div>
          </div>
        </div>
      </div>
      <div class="row mtb">
        <div class="col-md-6">
          <div class="cost">
            {{ driverData.truck_details[0]?.truck_number }}
          </div>
        </div>
      </div>
      <div
        class="row mtb flex flex-column"
        *ngIf="driverData.trip_details[0]?.pickup_date != null"
      >
        <div class="col-md-6">
          <div class="fare">Pickup Date :</div>
        </div>
        <div class="col-md-6">
          <div class="cost">
            {{ driverData.trip_details[0]?.pickup_date | date : "dd-MM-yyyy" }}
          </div>
        </div>
      </div>
    </div>

    <!-- fare BreakUp -->

    <div class="row mtb flex flex-column">
      <div class="col-md-6 border border-secondary"></div>
      <div class="col-md-6">
        <div class="Fare">Fare Breakup</div>
      </div>
    </div>
    <div class="tax-details">
      <div class="row mtb">
        <div class="col-md-6 fare-details">
          <div class="fare">Route Fare</div>
          <div class="cost">
            ₹
            <!-- {{ driverData.route_fare | number : "1.2-2" }} -->
            {{
              driverData.bidDetails[0]?.trip_status === "pending" ||
              driverData.bidDetails[0]?.trip_status === "trip_not_booked"
                ? (0 | number : "1.2-2")
                : ((driverData.workorderInfo[0]?.pay_as_load_quantity ===
                  "loaded_quantity"
                    ? (driverData.tripInfo?.workOrderOtherDetails
                        ?.price_per_ton || 0) *
                      (driverData.tripInfo?.workOrderOtherDetails
                        ?.loading_point || 0)
                    : driverData.workorderInfo[0]?.pay_as_load_quantity ===
                      "unloaded_quantity"
                    ? (driverData.tripInfo?.workOrderOtherDetails
                        ?.price_per_ton || 0) *
                      (driverData.tripInfo?.workOrderOtherDetails
                        ?.unloading_point || driverData.tripInfo?.workOrderOtherDetails?.loading_point || 0)
                    : driverData.trip_payment_info[0]?.price_details
                        ?.actual_price ||
                      driverData.price ||
                      0
                  ) | number : "1.2-2")
            }}
            /-
          </div>
        </div>
      </div>
      <div class="row mtb">
        <div class="col-md-6">
          <div class="deduct">Deductions</div>
        </div>
      </div>
      <div class="row mtb" *ngFor="let item of driverTax">
        <div class="col-md-6 fare-details">
          <div class="fare">
            {{ item.tax_name }}
            {{ item.tax_deduction }}
            {{ item.tax_type == "percent" ? "%" : "" }}
          </div>
          <div class="cost">
            <div
              class="card-details-right trip_details"
              *ngIf="item?.tax_type == 'percent'"
            >
              ₹
              <!-- {{ calculatedTax }} /- -->
              {{
                ((driverData.trip_payment_info[0]?.price_details
                  ?.actual_price ||
                  driverData.price ||
                  0) *
                  item.tax_deduction) /
                  100 | number : "1.2-2"
              }}
            </div>
            <div
              class="card-details-right trip_details"
              *ngIf="item.tax_type == 'amount'"
            >
              ₹ {{ item.tax_deduction }} /-
            </div>
          </div>
        </div>
      </div>
      <div class="row mtb">
        <div class="col-md-6 border"></div>
      </div>
      <div class="row mtb">
        <div class="col-md-6 fare-details">
          <div class="fare">Total Fare</div>
          <!-- For Normal Customers -->
          <div *ngIf="driverData?.trip_details[0]?.userInfo?.user_type === 'customer'">
            ₹ {{ driverData.total_fare | number: '1.2-2' }} /-
          </div>

          <!-- For Corporate Users -->
          <div *ngIf="driverData?.trip_details[0]?.userInfo?.user_type === 'corporate'">
            ₹
            {{
              driverData.bidDetails[0]?.trip_status === 'pending' ||
              driverData.bidDetails[0]?.trip_status === 'trip_not_booked'
                ? (0 | number: '1.2-2')
                : (
                    driverData.workorderInfo[0]?.pay_as_load_quantity === 'loaded_quantity'
                      ? (driverData.tripInfo?.workOrderOtherDetails?.price_per_ton || 0) *
                        (driverData.tripInfo?.workOrderOtherDetails?.loading_point || 0)
                      : driverData.workorderInfo[0]?.pay_as_load_quantity === 'unloaded_quantity'
                      ? (driverData.tripInfo?.workOrderOtherDetails?.price_per_ton || 0) *
                        (driverData.tripInfo?.workOrderOtherDetails?.unloading_point || driverData.tripInfo?.workOrderOtherDetails?.loading_point || 0)
                      : driverData.trip_payment_info[0]?.price_details?.amount_paid ||
                        driverData.total_fare || 0
                  ) | number: '1.2-2'
            }}
            /-

            <!-- ₹ {{ getTotalFare() | number : "1.2-2" }} /- -->
            <!-- ₹
            {{
              driverData.bidDetails[0]?.trip_status === "pending" ||
              driverData.bidDetails[0]?.trip_status === "trip_not_booked"
                ? (0 | number : "1.2-2")
                : ((driverData.workorderInfo[0]?.pay_as_load_quantity ===
                  "loaded_quantity"
                    ? (driverData.tripInfo?.workOrderOtherDetails
                        ?.price_per_ton || 0) *
                      (driverData.tripInfo?.workOrderOtherDetails
                        ?.loading_point || 0)
                    : driverData.workorderInfo[0]?.pay_as_load_quantity ===
                      "unloaded_quantity"
                    ? (driverData.tripInfo?.workOrderOtherDetails
                        ?.price_per_ton || 0) *
                      (driverData.tripInfo?.workOrderOtherDetails
                        ?.unloading_point || 0)
                    : driverData.trip_payment_info[0]?.price_details
                        ?.amount_paid ||
                      driverData.total_fare ||
                      0
                  ) | number : "1.2-2")
            }}
            /- -->
          </div>
        </div>
      </div>
      <div class="row mtb">
        <div class="col-md-6">
          <!-- Fare Label Based on User Type -->
          <div class="deduct" *ngIf="driverData?.trip_details[0]?.userInfo?.user_type === 'customer'">
            (Route Fare After Deductions)
          </div>

          <div class="deduct" *ngIf="driverData?.trip_details[0]?.userInfo?.user_type === 'corporate'">
            (Route Fare as Loaded/Unloaded Quantity)
          </div>
        </div>
      </div>
    </div>
    <div class="trip-details">
      <div class="row mtb">
        <div class="col-md-6 fare">Trip Details</div>
      </div>
      <div class="row mtb">
        <div class="col-md-6 d-flex justify-content-between">
          <div class="cost">
            Truck Category :
            {{ data.truck_category[0]?.truck_category_name }}
          </div>
          <div class="cost">
            Weight : {{ data.truck_type[0]?.truck_weight }}
          </div>
        </div>
      </div>
      <div class="row mtb" *ngIf="data.trip_details[0]?.load_type != null">
        <div class="col-md-6">
          <div class="cost">
            Load Type : {{ data.trip_details[0]?.load_type }} /
            {{ data.trip_details[0]?.material_type }}
          </div>
        </div>
      </div>
    </div>
    <div class="locations">
      <div class="row mtb">
        <div class="col-md-6 fare">Pickup and Dropoff Locations :-</div>
      </div>
      <div class="payment-container">
        <div class="location-payment">
          <div class="places">
            <div class="place-row">
              <mat-icon>near_me</mat-icon>
              <div class="place-text">
                <h4>{{ data?.fromLocation?.from_city_name }}</h4>
                {{ data?.tripInfo?.from_complete_address }}
                <div class="result">Contact Details: {{ data?.trip_details[0]?.pickup_name }} - {{ data?.trip_details[0]?.pickup_contact }}</div>
              </div>
            </div>
            <div class="place-row"
                *ngFor="let stop of data.stops; let i = index">
              <mat-icon>stop_circle</mat-icon>
              <div class="place-text">
                <h4>Stop {{ i + 1 }}: {{ stop.city_name }}</h4>
                {{ stop.complete_address }}
                <div class="result">Contact Details: {{ stop?.stop_contact_name }} - {{ stop?.stop_contact_number }}</div>
              </div>
            </div>
            <!-- Dropoff -->
            <div class="place-row">
              <mat-icon>location_on</mat-icon>
              <div class="place-text">
                <h4>{{ data?.toLocation?.to_city_name }}</h4>
                <div>{{ data?.tripInfo?.to_complete_address }}</div>
                <div class="result">Contact Details: {{ data.trip_details[0]?.dropoff_name }} - {{ data.trip_details[0]?.dropoff_contact }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="fare" *ngIf="transporter_details.length > 0">
      <h5>Payments Details</h5>
      <mat-divider></mat-divider>
      <form *ngFor="let item of transporter_details; let i = index">
        <div>
          <div class="fare mt-2">{{ getPaymentLabel(i + 1) }} Payment</div>
          <div class="row mt-3 ml-0 mr-0 d-flex">
            <div class="col-md-6">
              <div class="cost">Transation ID:</div>
              <h6>
                {{ item.transaction_id || "N/A" }}
              </h6>
            </div>
            <div class="col-md-6">
              <div class="cost">Amount:</div>
              <h6>{{ item.transaction_amount }}</h6>
            </div>
          </div>
          <div class="row mt-3 ml-0 mr-0 d-flex">
            <div class="col-md-6">
              <div class="cost">Pay Mode:</div>
              <h6>{{ item.payment_type | uppercase }}</h6>
            </div>
            <div class="col-md-6">
              <div class="cost">Pay Date:</div>
              <h6>
                {{ item.payment_date | date : "dd-MM-yyyy" }}
              </h6>
            </div>
          </div>
        </div>
      </form>
    </div>

    <div class="fare" *ngIf="driver_Trip_Details?.length > 0">
      <div class="heading">
        <h5>Trip History</h5>
        <mat-divider></mat-divider>
      </div>
      <!-- <div
        class="text-center mt-2"
        *ngIf="driverData?.trip_details?.trip_history.length == 0"
      >
        <div>
          <p>Trip has not started yet</p>
        </div>
      </div> -->

      <div class="row mb mt-4 mb-4 mr-0 ml-0">
        <div
          class="location-payment-2"
          *ngFor="let trip_history of driver_Trip_Details; let i = index"
        >
          <img
            src="../../../assets/img/dots.svg"
            *ngIf="trip_history.length - 1 != i"
          />
          <img
            src="../../../assets/img/dot_only.svg"
            *ngIf="trip_history.length - 1 == i"
          />
          <span class="places-2">
            <span>
              <h4 class="trip_Details">{{ trip_history.name }}:</h4>
              <h6>
                {{ trip_history.date | date : "dd-MM-yyyy" }}
                &nbsp;&nbsp;&nbsp;
                {{ trip_history.date | date : "HH:mm:ss a" }}
              </h6>
            </span>
          </span>
        </div>
      </div>
    </div>

    <div class="fare" *ngIf="data.notes_details.length != 0">
      <div class="heading">
        <h5>View Notes</h5>
        <mat-divider></mat-divider>
      </div>
      <div
        class="row mb mr-0 ml-0"
        *ngFor="let item of driver_View_Notes; let i = index"
      >
        <div class="col-sm-3">
          <div class="note1">Note {{ i + 1 }}:</div>
          <div class="note2">{{ item.employee_name }}</div>

          <div class="note3">{{ item.date | date : "medium" }}</div>
        </div>
        <div class="col-sm-9">
          <div class="note2">
            {{ item.notes }}
          </div>
        </div>
      </div>
    </div>

    <div
      class="row ml-0 mr-0 d-flex justify-content-between align-items-center"
    >
      <div class="col-md-6 d-flex justify-content-between">
        <button
          type="button"
          class="btn button buttonBlue"
          (click)="consignment(driverData)"
        >
          Consignment Note
        </button>
      </div>
      <div class="col-md-4">
        <button
          type="button"
          class="btn button buttonCancel pull-right me-3"
          *ngIf="driverData?.driver_trip_route_status == 'new_route'"
          (click)="cancelTrip(driverData._id)"
        >
          Cancel DRO
        </button>
      </div>
    </div>
  </div>
</section>
